import {
  createQueryKeyStore,
  inferQueryKeyStore,
} from "@lukemorales/query-key-factory"
import { newsfeedApiClient } from "./client"
import type { ArticleQueryParams } from "@/models/newsfeed/newsfeed.types"
import type {
  IArticleRaw,
  IPaginatedArticlesResponse,
} from "@/models/newsfeed/newsfeed.parser"

export const NewsfeedQueries = createQueryKeyStore({
  articles: {
    published: (params?: ArticleQueryParams) => ({
      queryKey: [JSON.stringify(params)],
      queryFn: () =>
        newsfeedApiClient.get<IPaginatedArticlesResponse>("/articles", {
          params,
        }),
    }),
    detail: (id: string) => ({
      queryKey: [id],
      queryFn: () => newsfeedApiClient.get<IArticleRaw>(`/articles/${id}`),
    }),
  },
  admin: {
    articles: (params?: ArticleQueryParams) => ({
      queryKey: [JSON.stringify(params)],
      queryFn: () =>
        newsfeedApiClient.get<IPaginatedArticlesResponse>("/admin/articles", {
          params,
        }),
    }),
    article: (id: string) => ({
      queryKey: [id],
      queryFn: () =>
        newsfeedApiClient.get<IArticleRaw>(`/admin/articles/${id}`),
    }),
  },
})

export type NewsfeedQueryKeys = inferQueryKeyStore<typeof NewsfeedQueries>
